<template>
    <div>
        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="/">{{$t('app.center')}}</el-menu-item>
            <el-submenu index="2">
                <template slot="title">{{$t('app.lang')}}</template>
                <el-menu-item @click="onLang('zh')">中文</el-menu-item>
                <el-menu-item @click="onLang('en')">English</el-menu-item>
                <el-menu-item @click="onLang('fr')">Français</el-menu-item>
            </el-submenu>
        </el-menu>
        <div class="mt-2">
            <el-card>
                <el-tabs v-model="tabName" @tab-click="tabHandle">
                    <el-tab-pane :label="$t('ftype.1')" name="0"></el-tab-pane>
                    <el-tab-pane :label="$t('ftype.2')" name="1"></el-tab-pane>
                    <el-tab-pane :label="$t('ftype.3')" name="2"></el-tab-pane>
                    <el-tab-pane :label="$t('ftype.4')" name="3"></el-tab-pane>
                </el-tabs>
                <div>
                    <el-table :data="list" border>
                        <el-table-column prop="order_no" :label="$t('app.order_no')"></el-table-column>
                        <el-table-column :label="$t('app.status')">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ongoing==1" class="text-danger">
                                    {{$t('ontype.'+scope.row.status)}}
                                </span>
                                <span v-else>{{$t('wtype.'+scope.row.status)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="130">
                            <template slot="header"><span>{{$t('app.operation')}}</span></template>
                            <template slot-scope="scope">
                                <el-button type="primary" v-if="scope.row.status<4"
                                           @click="goCreate(scope.row)"
                                           size="mini">{{$t('ftype.'+(+scope.row.status+1))}}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total,prev, pager, next" v-if="page.total>0"
                                   :page-size="page.size" :total="page.total"
                                   @current-change="onChangePage">
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                tabName: '0',
                page: {},
                list: [],
                status: 0,
            };
        },
        created() {
            if (this.$route.query.tab) {
                this.tabName = this.$route.query.tab;
                this.status = this.tabName;
            }
            this.loadList();
        },
        methods: {
            loadList() {
                this.$api.get('order/index', {
                    page: this.page.current,
                    status: this.status,
                }).then(res => {
                    if (res.code == 0) {
                        this.list = res.data.list;
                        this.page = res.data.page;
                    }
                })
            },
            tabHandle() {
                this.page.current = 1;
                this.status = this.tabName;
                this.$router.replace({name: 'index', query: {tab: this.tabName}});
                this.loadList();
            },
            goCreate(row) {
                this.$router.push('/create/' + (row.status + 1) + '/' + row.id);
            },
            onChangePage(e) {
                this.page.current = e;
                this.loadList();
            },
            onLang(lang) {
                this.$i18n.locale = lang;
                localStorage.setItem('lang', lang);
            }
        },
    }
</script>

<style scoped>

</style>